// @flow
module.exports = {
    convert: function(containerClass:Object ):Object  {
        const tmp = containerClass;
        containerClass = function(...args):Object  {
            return new tmp(...args);
        };
        containerClass.prototype = tmp.prototype;
        containerClass.getStores = tmp.getStores;
        containerClass.calculateState = tmp.calculateState;
        return containerClass;
    }
};